export default {
  login: {
    welcome: 'Selamat kembali',
    subtitle: 'Log masuk untuk meneruskan pembelian',
    phonePlaceholder: 'Sila masukkan nombor telefon',
    passwordPlaceholder: 'Sila masukkan kata laluan',
    showPassword: 'Papar',
    hidePassword: 'Sembunyi',
    loginButton: 'Log masuk',
    registerButton: 'Daftar percuma',
    title: 'Log masuk',
    subtitle2: 'Beli-belah global sehenti untuk mendapat ganjaran',
    logging: 'Sedang log masuk...',
    phoneRequired: 'Sila masukkan nombor telefon',
    passwordRequired: 'Sila masukkan kata laluan',
    loginSuccess: 'Log masuk berjaya',
    loginFailed: 'Log masuk gagal',
    loginError: 'Ralat log masuk, sila cuba lagi'
  },
  register: {
    title: 'Cipta akaun',
    subtitle: 'Sertai kami dan mulakan perjalanan dagangan anda',
    username: 'Nama pengguna',
    phone: 'Nombor telefon',
    loginPassword: 'Kata laluan log masuk',
    transactionPassword: 'Kata laluan transaksi',
    invitationCode: 'Kod jemputan',
    usernamePlaceholder: 'Sila masukkan nama pengguna',
    phonePlaceholder: 'Sila masukkan nombor telefon',
    loginPasswordPlaceholder: 'Sila masukkan kata laluan',
    transactionPasswordPlaceholder: 'Sila masukkan kata laluan transaksi',
    invitationCodePlaceholder: 'Sila masukkan kod jemputan',
    registerButton: 'Daftar',
    hasAccount: 'Sudah mempunyai akaun? Log masuk',
    errorUsername: 'Sila masukkan nama pengguna',
    errorPhone: 'Sila masukkan nombor telefon',
    errorLoginPassword: 'Sila masukkan kata laluan log masuk',
    errorTransactionPassword: 'Sila masukkan kata laluan transaksi',
    errorInviteCode: 'Sila masukkan kod jemputan',
    registerSuccess: 'Pendaftaran berjaya'
  },
  tabbar: {
    home: 'Laman Utama',
    purchase: 'Pesanan',
    grabbing: 'Rebut',
    kefu: 'Khidmat Pelanggan',
    my: 'Profil Saya'
  },
  home: {
    orderCount: 'Jumlah Pesanan',
    upgradeAmount: 'Tambah nilai untuk naik taraf',
    recharge: 'Tambah Nilai',
    withdraw: 'Keluarkan',
    team: 'Pengurusan Pasukan',
    commission: 'Dapatkan Komisen',
    newProducts: 'Produk Baharu',
    newProductsDesc: 'Koleksi musim baharu dan akan datang yang terkini.',
    buyNow: 'Beli Sekarang',
    nowAvailable: 'Kini Tersedia',
    nowAvailableDesc: 'Bersedia untuk musim perkahwinan, berkemas untuk percutian seterusnya, dan kemas kini almari pakaian anda tanpa komitmen. Melalui pelan pinjaman baharu kami, anda boleh mencuba trend terkini mengikut bajet anda tanpa langganan.',
    footerTitle: 'Desigual.com',
    footerFollow: "Ikuti kami di {'@'}Desigual.com dan kongsikan gaya Desigual.com kegemaran anda!",
    footerShop: 'Semak imbas suapan kami'
  },
  purchase: {
    all: 'Semua',
    pending: 'Menunggu',
    completed: 'Selesai',
    frozen: 'Dibekukan',
    balance: 'Baki Akaun',
    orderTime: 'Masa Pesanan',
    orderId: 'ID Pesanan',
    totalAmount: 'Jumlah Keseluruhan',
    commission: 'Komisen',
    expectedReturn: 'Jangkaan Pulangan',
    submitOrder: 'Hantar Pesanan',
    orderCompleted: 'Pesanan Selesai',
    loading: 'Sedang memuatkan...',
    noData: 'Tiada data pesanan',
    noMore: 'Tiada lagi',
    orderSuccess: 'Rebutan berjaya',
    orderNumber: 'Nombor Pesanan',
    rating: 'Penilaian',
    notSubmit: 'Belum Hantar',
    submitNow: 'Hantar Sekarang',
    submitting: 'Sedang menghantar...',
    submitFailed: 'Gagal menghantar',
    grabOrderFailed: 'Gagal merebut pesanan, sila cuba lagi',
    getOrderInfoFailed: 'Gagal mendapatkan butiran pesanan',
    submitOrderFailed: 'Gagal menghantar pesanan, sila cuba lagi'
  },
  common: {
    home: 'Laman Utama',
    about: 'Mengenai Kami',
    contact: 'Hubungi Kami',
    purchase: 'Rekod Pesanan',
    grabbing: 'Buat Pesanan',
    my: 'Profil Saya',
    login: 'Log masuk',
    register: 'Daftar',
    kefu: 'Khidmat Pelanggan',
    loadDataError: 'Gagal memuatkan data, sila cuba lagi',
    success: 'Operasi berjaya',
    failed: 'Operasi gagal',
    submitSuccess: 'Berjaya dihantar',
    submitFailed: 'Gagal dihantar',
    submitting: 'Sedang menghantar...'
  },
  grabbing: {
    accountAmount: 'Jumlah Akaun',
    accountBalance: 'Baki Akaun',
    getCommission: 'Dapatkan Komisen',
    ordersGrabbedToday: 'Pesanan Direbut',
    orderCount: 'Jumlah Pesanan',
    operationSteps: 'Langkah Operasi',
    step1: '1. Klik butang mula tugas dan ikut arahan untuk melengkapkan tugas',
    step2: '2. Selepas melengkapkan tugas, komisen akan dimasukkan ke dalam baki anda',
    grabOrder: 'Mula Merebut',
    pleaseWait: 'Sila tunggu',
    grabSuccess: 'Rebutan berjaya',
    grabTime: 'Masa Rebutan',
    grabNumber: 'Nombor Rebutan',
    orderTotal: 'Jumlah Pesanan',
    commission: 'Komisen',
    expectedReturn: 'Jangkaan Pulangan',
    rating: 'Penilaian',
    notSubmit: 'Belum Hantar',
    submitNow: 'Hantar Sekarang',
    submitting: 'Sedang menghantar...'
  },
  kefu: {
    title: 'Khidmat Pelanggan',
    intro: {
      line1: 'Jika anda mempunyai sebarang soalan atau memerlukan bantuan,',
      line2: 'sila hubungi khidmat pelanggan dalam talian kami.'
    },
    serviceTime: {
      label: 'Waktu Perkhidmatan',
      text: 'Khidmat pelanggan eksklusif anda',
      online: 'Dalam Talian'
    },
    contact: {
      title: 'Hubungi',
      name: 'Dalam Talian',
      status: 'Pertanyaan',
      feature1: 'Balasan Segera',
      feature2: 'Servis Profesional',
      button: 'Hubungi'
    },
    faq: {
      title: 'Soalan Lazim (FAQ)',
      rechargeQuestion: 'Bagaimana untuk menambah nilai?',
      rechargeAnswer: 'Anda boleh menambah nilai melalui gerbang pembayaran selamat kami. Pergi ke Akaun Saya > Tambah Nilai dan ikut arahan.',
      withdrawQuestion: 'Bagaimana untuk mengeluarkan wang?',
      withdrawAnswer: 'Pengeluaran boleh dilakukan melalui Akaun Saya > Keluarkan. Pastikan akaun anda telah disahkan.',
      minRechargeQuestion: 'Berapakah jumlah minimum untuk tambah nilai?',
      minRechargeAnswer: 'Jumlah minimum tambah nilai ialah ${currency}68.',
      withdrawTimeQuestion: 'Berapa lamakah masa yang diambil untuk pengeluaran?',
      withdrawTimeAnswer: 'Pengeluaran biasanya diproses dalam masa 24 jam.',
      securityQuestion: 'Adakah maklumat saya selamat?',
      securityAnswer: 'Ya, kami menggunakan teknologi penyulitan standard industri untuk melindungi maklumat peribadi dan kewangan anda.'
    }
  },
  my: {
    inviteCode: 'Kod Jemputan',
    copy: 'Salin',
    copySuccess: 'Berjaya disalin',
    copyFailed: 'Gagal disalin',
    online: 'Dalam Talian',
    accountBalance: 'Jumlah Akaun',
    balance: 'Baki Akaun',
    accountBalanceTrend: 'Trend Baki Akaun',
    todayCommission: 'Komisen Hari Ini',
    totalCommission: 'Jumlah Komisen',
    today: 'Hari Ini',
    total: 'Jumlah',
    todayOrders: 'Pesanan Direbut',
    orderCount: 'Jumlah Pesanan',
    recharge: 'Tambah Nilai',
    withdraw: 'Keluarkan',
    rechargeRecord: 'Rekod Tambah Nilai',
    withdrawRecord: 'Rekod Pengeluaran',
    accountDetails: 'Butiran Akaun',
    receivingAccount: 'Akaun Penerima',
    bankAccount: 'Akaun Bank',
    bankAccountDesc: 'Akaun Bank',
    usdt: 'USDT',
    usdtDesc: 'Alamat USDT',
    connect: 'Sambung',
    teamManagement: 'Pengurusan Pasukan',
    viewTeam: 'Lihat Pasukan',
    changePassword: 'Tukar Kata Laluan',
    changeWithdrawPassword: 'Tukar Kata Laluan Pengeluaran',
    passwordSettings: 'Tetapan Kata Laluan',
    logout: 'Log Keluar',
    signOut: 'Log Keluar',
    version: 'Versi'
  },
  changePasswordPage: {
    currentPassword: 'Kata Laluan Log Masuk Semasa',
    currentPasswordPlaceholder: 'Masukkan kata laluan semasa',
    newPassword: 'Kata Laluan Log Masuk Baharu',
    newPasswordPlaceholder: 'Masukkan kata laluan baharu',
    confirmPassword: 'Sahkan Kata Laluan Log Masuk',
    confirmPasswordPlaceholder: 'Sahkan kata laluan baharu',
    notice: 'Kata laluan log masuk digunakan untuk log masuk akaun. Kata laluan mesti mempunyai sekurang-kurangnya 6 aksara, dan mengandungi huruf serta nombor untuk keselamatan.',
    updateButton: 'Kemaskini Kata Laluan Log Masuk',
    errorOldPassword: 'Sila masukkan kata laluan semasa',
    errorNewPassword: 'Sila masukkan kata laluan baharu',
    errorConfirmPassword: 'Sila sahkan kata laluan baharu',
    errorPasswordMismatch: 'Kata laluan yang dimasukkan tidak sepadan',
    errorPasswordLength: 'Kata laluan mesti sekurang-kurangnya 6 aksara',
    errorPasswordFormat: 'Kata laluan mesti mengandungi huruf dan nombor'
  },
  changeWithdrawPasswordPage: {
    currentPassword: 'Kata Laluan Pengeluaran Semasa',
    currentPasswordPlaceholder: 'Masukkan kata laluan pengeluaran semasa',
    newPassword: 'Kata Laluan Pengeluaran Baharu',
    newPasswordPlaceholder: 'Masukkan kata laluan pengeluaran baharu',
    confirmPassword: 'Sahkan Kata Laluan Pengeluaran',
    confirmPasswordPlaceholder: 'Sahkan kata laluan pengeluaran baharu',
    notice: 'Kata laluan pengeluaran digunakan untuk operasi pengeluaran dana. Kata laluan mesti mempunyai sekurang-kurangnya 6 aksara, dan mengandungi huruf serta nombor untuk keselamatan.',
    updateButton: 'Kemaskini Kata Laluan Pengeluaran',
    errorOldPassword: 'Sila masukkan kata laluan pengeluaran semasa',
    errorNewPassword: 'Sila masukkan kata laluan pengeluaran baharu',
    errorConfirmPassword: 'Sila sahkan kata laluan pengeluaran baharu',
    errorPasswordMismatch: 'Kata laluan yang dimasukkan tidak sepadan',
    errorPasswordLength: 'Kata laluan mesti sekurang-kurangnya 6 aksara',
    errorPasswordFormat: 'Kata laluan mesti mengandungi huruf dan nombor'
  },
  details: {
    loading: 'Sedang memuatkan...',
    noRecords: 'Tiada rekod',
    noMore: 'Tiada lagi',
    time: 'Masa',
    type: 'Jenis',
    amount: 'Jumlah',
    balance: 'Baki',
    remark: 'Catatan',
    type0: 'Lain-lain',
    type1: 'Tambah Nilai',
    type2: 'Pengeluaran',
    type3: 'Transaksi',
    type4: 'Komisen Pesanan',
    type5: 'Rebat Subordinat',
    type8: 'Pengeluaran Ditolak'
  },
  rechargeRecord: {
    offline: 'Tambah Nilai Luar Talian',
    online: 'Tambah Nilai Atas Talian',
    loading: 'Sedang memuatkan...',
    noRecords: 'Tiada rekod',
    orderNo: 'No. Pesanan',
    rechargeAmount: 'Jumlah Tambah Nilai',
    rechargeTime: 'Masa Tambah Nilai',
    payMethod: 'Kaedah Pembayaran',
    rechargeStatus: 'Status Tambah Nilai',
    noMore: 'Tiada lagi',
    statusPending: 'Menunggu Kelulusan',
    statusApproved: 'Diluluskan',
    statusFailed: 'Gagal',
    statusEmpty: ''
  },
  withdrawRecord: {
    loading: 'Sedang memuatkan...',
    noRecords: 'Tiada rekod',
    orderNo: 'No. Pesanan',
    withdrawAmount: 'Jumlah Pengeluaran',
    withdrawTime: 'Masa Pengeluaran',
    withdrawAddress: 'Alamat Pengeluaran',
    withdrawStatus: 'Status Pengeluaran',
    noMore: 'Tiada lagi',
    statusPending: 'Sedang Diproses',
    statusApproved: 'Berjaya',
    statusFailed: 'Gagal',
    statusEmpty: ''
  },
  withdraw: {
    title: 'Keluarkan',
    method: 'Kaedah Pengeluaran',
    methodSubtitle: 'Sila pilih kaedah pengeluaran anda',
    bankInfo: 'Maklumat Akaun Bank',
    bankName: 'Nama Bank',
    accountHolder: 'Nama Pemegang Akaun',
    bankCard: 'Kad Bank',
    amount: 'Jumlah Pengeluaran',
    balance: 'Baki',
    withdrawAll: 'Keluarkan Semua',
    paymentPassword: 'Kata Laluan Pembayaran',
    passwordPlaceholder: 'Sila masukkan kata laluan dana',
    principal: 'Jumlah Prinsipal',
    serviceFee: 'Caj Perkhidmatan',
    netAmount: 'Jumlah Bersih',
    notice: '*Sila semak maklumat penerima dengan teliti',
    withdrawButton: 'Keluarkan',
    walletAddress: 'Alamat Dompet',
    walletAddressSubtitle: 'Sila masukkan alamat dompet'
  },
  recharge: {
    title: 'Tambah Nilai',
    amount: 'Jumlah Tambah Nilai',
    amountSubtitle: 'Sila masukkan jumlah yang ingin ditambah',
    quickSelect: 'Pilihan Pantas',
    rechargeNow: 'Tambah Nilai Sekarang',
    selectPayment: 'Pilih Kaedah Pembayaran',
    selectPaymentSubtitle: 'Sila pilih kaedah pembayaran pilihan anda',
    cancel: 'Batal',
    confirm: 'Sahkan',
    crypto: 'Mata Wang Kripto',
    bank: 'Pindahan Bank',
    paymentRange: 'Minimum: {symbol}{minAmount} - Maksimum: {symbol}{maxAmount}',
    rechargeFailed: 'Tambah Nilai Gagal',
    paymentInfo: 'Maklumat Pembayaran',
    usercode: 'Alamat USDT',
    uploadScreenshot: 'Sila muat naik tangkapan skrin pembayaran',
    clickToUpload: 'Klik untuk muat naik',
    copySuccess: 'Berjaya disalin',
    copyFailed: 'Gagal disalin',
    uploadScreenshotRequired: 'Sila muat naik tangkapan skrin pembayaran',
    submit: 'Hantar',
    submitting: 'Sedang menghantar...',
    submitSuccess: 'Berjaya dihantar',
    submitFailed: 'Gagal dihantar'
  },
  bindUsdt: {
    title: 'Ikat USDT',
    cardTitle: 'Alamat USDT',
    cardSubtitle: 'Masukkan alamat dompet USDT anda',
    walletAddress: 'Alamat Dompet',
    walletAddressPlaceholder: 'Sila masukkan alamat dompet USDT',
    networkType: 'Jenis Rangkaian',
    networkTypePlaceholder: 'Sila pilih jenis rangkaian',
    withdrawPassword: 'Kata Laluan Pengeluaran',
    withdrawPasswordPlaceholder: 'Sila masukkan kata laluan pengeluaran',
    trc20: 'TRC20',
    trc20Network: 'Rangkaian TRC20',
    erc20: 'ERC20',
    erc20Network: 'Rangkaian ERC20',
    securityNotice: 'Notis Keselamatan',
    securityText1: '• Alamat USDT anda disulitkan dan disimpan dengan selamat',
    securityText2: '• Hanya anda yang boleh melihat dan mengubah maklumat ini',
    securityText3: '• Sila pastikan semua maklumat adalah tepat',
    buttonText: 'Simpan Maklumat',
    buttonSubtitle: 'Ikat Alamat USDT',
    errorWalletAddress: 'Sila masukkan alamat dompet',
    errorNetworkType: 'Sila pilih jenis rangkaian',
    errorWithdrawPassword: 'Sila masukkan kata laluan pengeluaran'
  },
  team: {
    title: 'Pengurusan Pasukan',
    level1: 'Pasukan Tahap 1',
    level2: 'Pasukan Tahap 2',
    level3: 'Pasukan Tahap 3',
    level1Members: 'Ahli Tahap 1',
    level2Members: 'Ahli Tahap 2',
    level3Members: 'Ahli Tahap 3',
    totalMembers: 'Jumlah Ahli',
    totalCommission: 'Jumlah Komisen',
    members: 'Orang',
    orders: 'Pesanan',
    commission: 'Komisen',
    noMembers: 'Tiada ahli',
    loading: 'Sedang memuatkan...',
    noMore: 'Tiada lagi'
  },
  bindBank: {
    title: 'Ikat Kad Bank',
    cardTitle: 'Maklumat Bank',
    cardSubtitle: 'Pilih bank anda dan masukkan butiran akaun',
    bankName: 'Nama Bank',
    bankNamePlaceholder: 'Sila masukkan nama bank',
    cardNumber: 'Nombor Kad Bank',
    cardNumberPlaceholder: 'Sila masukkan nombor kad bank',
    realName: 'Nama Sebenar',
    realNamePlaceholder: 'Sila masukkan nama sebenar',
    withdrawPassword: 'Kata Laluan Pengeluaran',
    withdrawPasswordPlaceholder: 'Sila masukkan kata laluan pengeluaran',
    securityNotice: 'Notis Keselamatan',
    securityText1: '• Maklumat bank anda disulitkan dan disimpan dengan selamat',
    securityText2: '• Hanya anda yang boleh melihat dan mengubah maklumat ini',
    securityText3: '• Sila pastikan semua maklumat adalah tepat',
    buttonText: 'Simpan Maklumat',
    buttonSubtitle: 'Ikat Akaun Bank',
    errorBankName: 'Sila masukkan nama bank',
    errorCardNumber: 'Sila masukkan nombor kad bank',
    errorRealName: 'Sila masukkan nama sebenar',
    errorWithdrawPassword: 'Sila masukkan kata laluan pengeluaran'
  }
}